import { createSelector } from '@reduxjs/toolkit';

import { flattenFilterGridItemsSelector } from '@/features/config/selectors';
import configSelector from '@/features/config/selectors/config';

import getFiltersParameters from '../helpers/getFiltersParameters';

import immutableFilterQueriesSelector from './immutableQueries';
import filterQueriesSelector from './queries';

/**
 * Получить параметры запроса на получение агрегации фильтров
 */
const aggregateFiltersParametersSelector = createSelector(
  [
    configSelector,
    flattenFilterGridItemsSelector,
    immutableFilterQueriesSelector,
    filterQueriesSelector,
  ],
  (config, filters, immutableQueries, queries) => {
    return getFiltersParameters(config, filters, {
      q: [...immutableQueries.q, ...queries.q],
      qMap: {
        ...immutableQueries.qMap,
        ...queries.qMap,
      },
    });
  },
);

export default aggregateFiltersParametersSelector;
